import axios from "axios";
import { TEarnings } from "../types/reports";

export const ReportTransport = {
    findWordDeliveredPerWriter: async () => {
        const { data } = await axios.get(`/reports/findWordDeliveredPerWriter`, {});
        return data.map((el: any, index: number) => ({ ...el, id: index }));
    },
    findOrdersReviewedPerWeek: async () => {
        const { data } = await axios.get(`/reports/findOrdersReviewedPerWeek`, {});
        return data.map((el: any, index: number) => ({ ...el, id: index }));
    },
    findWritersBillingPerMonth: async () => {
        const { data } = await axios.get(`/reports/findWritersBillingPerMonth`, {});
        return data.map((el: any, index: number) => ({ ...el, id: index }));
    },
    findProofreadersBillingPerMonth: async () => {
        const { data } = await axios.get(`/reports/findProofreadersBillingPerMonth`, {});
        return data.map((el: any, index: number) => ({ ...el, id: index }));
    },
    findEarningsTotalTurnover: async (): Promise<Array<TEarnings>> => {
        const { data } = await axios.get(`/reports/findEarnings/turnover`, {});
        return data;
    },
    findEarningsByPlatform: async (): Promise<Array<TEarnings>> => {
        const { data } = await axios.get(`/reports/findEarnings/platform`, {});
        return data;
    },
    findExpenses: async (yearSelected: number): Promise<Array<TEarnings>> => {
        const { data } = await axios.get(`/reports/findExpenses?year=${yearSelected}`, {});
        return data;
    },
};
